export const setRegisterProductData = (payload) => ({
  type: 'SET_REGISTER_PRODUCT_DATA',
  payload,
});
